<div class="toolbar-item justify-center align-middle flex flex-col m-1 mt-2" [routerLink]="item.route">

    <div [ngClass]="{'flex flex-row shrink flex-grow gap-2': true, 'active': validateUrlActive() }">
      <img class="toolbar-item__icon toolbar-item__icon w-fit box-border h-5" [src]="item.icon" *ngIf="item?.icon !== undefined && item?.icon !== null" alt="icons" />
      <p [ngClass]="{'toolbar-item__title text-center text-white font-medium text-sm': true}">{{item.title}}</p>
    </div>
    <ng-container *ngIf="validateUrl()">

      <div class="flex justify-center ml-5" >
         <svg width="17" height="5" viewBox="0 0 34 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M30.8753 19C31.345 18.9999 31.8041 18.8605 32.1946 18.5996C32.5851 18.3386 32.8894 17.9677 33.0691 17.5338C33.2488 17.0998 33.2959 16.6224 33.2043 16.1617C33.1127 15.7011 32.8866 15.2779 32.5545 14.9458L18.3041 0.695387C17.8587 0.250131 17.2547 0 16.6249 0C15.9952 0 15.3912 0.250131 14.9458 0.695387L0.695388 14.9458C0.363332 15.2779 0.13721 15.7011 0.0456093 16.1617C-0.0459911 16.6224 0.00104294 17.0998 0.180764 17.5338C0.360485 17.9677 0.664825 18.3386 1.05531 18.5996C1.44579 18.8605 1.90489 18.9999 2.37456 19H30.8753Z" fill="white
            "/>
          </svg>
      </div>
    </ng-container>
</div>

